import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import Links from './components/Links';

function DestinationLinksComponent({ destinations }) {
  return (
    <DestinationsLinksWrapper>
      <Message>
        <FormattedMessage
          id='coronaVirusTemplate.noticeAboutTravelRestrictions.message'
          description='On this destinations travel restrictions may apply. Please check the following links for the latest information.'
          defaultMessage='On this destinations travel restrictions may apply. Please check the following links for the latest information.'
        />
      </Message>
      <List>
        {destinations &&
          destinations.map(({ destinationName, travelInfoUrls }) => (
            <Links
              key={`destination-${destinationName}`}
              destinationName={destinationName}
              travelInfoUrls={travelInfoUrls}
            />
          ))}
      </List>
    </DestinationsLinksWrapper>
  );
}

export default DestinationLinksComponent;

const DestinationsLinksWrapper = styled.div``;

const List = styled.ul`
  padding-top: 14px;
  list-style-type: disc;

  > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const Message = styled.p`
  margin-bottom: 8px;
  font-size: 1.6em;
`;
